import './UsersPageModals.scss';

import React from 'react';
import update from 'immutability-helper';

import GroupEditForm from '../modals/GroupEditForm';
import Modal from 'components/Modal';
import Thumbnail from 'components/Thumbnail';

export default class GroupEditModal extends React.Component {
    static propTypes = {
        cancelModal: React.PropTypes.func.isRequired,
        closeModal: React.PropTypes.func.isRequired,
        group: React.PropTypes.object.isRequired,
        handleThumbnailSelectedToUpload: React.PropTypes.func.isRequired,
        isSaving: React.PropTypes.bool.isRequired,
        saveGroup: React.PropTypes.func.isRequired,
        setGroup: React.PropTypes.func.isRequired,
        show: React.PropTypes.bool.isRequired,
        thumbnailToUpload: React.PropTypes.object
    };

    _handleChange(event) {
        let name = event.target.getAttribute('name');
        let newGroupObj = update(this.props.group, {});
        newGroupObj[name] = event.target.value;

        this.props.setGroup(newGroupObj);
    }

    _handleSave(isValid) {
        if(isValid === true) {
            this.props.saveGroup();
        }
    }

    render() {
        let { cancelModal, closeModal, handleThumbnailSelectedToUpload, isSaving, show, thumbnailToUpload, group } = this.props;

        return (
            <Modal show={show}
                   className="group-edit edit-modal"
                   handleClose={closeModal.bind(this)}>
                <header className="group-edit__header group-modal__header">
                    <div className="group-modal__thumbnail group-edit__thumbnail upload-thumbnail">
                        <Thumbnail defaultAvatar="groups"
                                   dropzone={true}
                                   handleDrop={handleThumbnailSelectedToUpload.bind(this)}
                                   thumbnailID={group.thumbnail ? group.thumbnail.id : null}
                                   thumbnailToUpload={thumbnailToUpload} />
                    </div>
                </header>
                <div className="group-edit__form-wrapper">
                    <GroupEditForm closeModal={cancelModal.bind(this)}
                                   group={group}
                                   handleChange={this._handleChange.bind(this)}
                                   isSaving={isSaving}
                                   onValid={this._handleSave.bind(this, true)}
                                   onInvalid={this._handleSave.bind(this, false)} />

                </div>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/UsersPage/modals/GroupEditModal.js